import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Atividades from '../../../../../components/Atividades/Atividades';
import Bullets from '../../../../../components/Bullets/Bullets';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import { CustomButton } from '../../../../../components/CustomButton';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import { HelpButton } from '../../../../../components/HelpButton';
import ArrowBackIcon from '../../../../../components/Icons/ArrowBackIcon';
import ArrowDownwardIcon from '../../../../../components/Icons/ArrowDownwardIcon';
import { Row } from '../../../../../components/Row';
import { CONTRATO_EDIT_ETAPA_VALIDACAO } from '../../../../../library/ContratoEditEtapas';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';
import {
  contratoAditivoEditRoute,
  contratoDistratoEditRoute,
  contratoEditRoute,
} from '../../../../../library/Routes';
import {
  cadastroAditivoEntePrivado,
  cadastroContratoEntePrivado,
  cadastroDistratoEntePrivado,
  changeContratoEntePrivadoEditingValue,
  editarAditivoEntePrivado,
  editarDistratoEntePrivado,
  editarEntePrivado,
} from '../../../../../store/modules/ContratosEntePrivadoActions';
import { openModal } from '../../../../../store/modules/ModalActions';
import { fixAllAtividadesIndex } from '../../../../../utils/ContratoEntePrivadoUtils';
import { getContratoTipoByRouteParams } from '../../../../../utils/ContratoUtils';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import CadastroAtividadesModal from './CadastroAtividadesModal';
import styles from './DadosAtividades.scss';
import GenericDados from './GenericDados';
import { AddIcon } from 'assets/icons/AddIcon';

const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  sending: false,

  dataInicioChanged: false,
  totalMesesChanged: false,
  dataFimChanged: false,
  reembolsoChanged: false,
};

class DadosAtividades extends GenericDados {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  finishButtomIsDisabled() {
    if (
      this.props.contratosEntePrivado.contratoEditing.escolaCompromissoCheck &&
      this.props.contratosEntePrivado.contratoEditing.atividades.length === 0
    ) {
      return true;
    }
    return false;
  }

  getActions = () => {
    return (
      <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
        {this.props.contratosEntePrivado.contratoEditing.atividades.length >
        0 ? (
          <Col
            cols={[12, 12, 12, 12, 12]}
            className={
              genericCardStyles.rootClassName + '-modal-cadastro-buttom'
            }
          >
            <CustomButton
              className={rootClassName + `-modal-cadastro-buttom`}
              label={this.props.languageValues.cadastroAtividadeButtom}
              theme='pufvYellow'
              onClick={this.addAtividade}
              disabled={this.fieldDisabled()}
              rightIcon={<AddIcon />}
            />
          </Col>
        ) : null}
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-left'}
        >
          <CustomButton
            label={this.props.languageValues.anterior}
            theme='pufvYellow'
            onClick={this.toPrevContent}
            leftIcon={<ArrowBackIcon />}
          />
        </Col>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-right'}
        >
          <CustomButton
            label={this.props.languageValues.concluirEAvancarEtapa}
            theme='pufvYellow'
            onClick={() => {
              if (this.formIsValid()) {
                if (this.props.utils.editing()) {
                  this.toEdit(
                    this.props.contratosEntePrivado.contratoEditing.idContrato,
                    2,
                    this.props.contratosEntePrivado.contratoEditing,
                    this.submitCallbackStart,
                    this.submitCallbackSuccess,
                    this.submitCallbackError
                  );
                } else {
                  this.toSubmit(
                    2,
                    this.props.contratosEntePrivado.contratoEditing,
                    this.submitCallbackStart,
                    this.submitCallbackSuccess,
                    this.submitCallbackError
                  );
                }
              }
            }}
            rightIcon={<ArrowDownwardIcon />}
            disabled={
              this.submitButtonIsDisabled() || this.finishButtomIsDisabled()
            }
          />
        </Col>
      </Row>
    );
  };

  submitButtonIsDisabled = () => {
    if (this.hasPermissions()) {
      return this.props.loading || this.state.sending || !this.formIsValid();
    }
    return true;
  };

  fieldDisabled = () => {
    if (!this.hasPermissions()) {
      return true;
    }
    const editing = this.editing();
    if (editing) {
      if (!this.props.auth.userPermissions.contratos.entePrivado.edit) {
        return true;
      }
    }
    return this.state.sending || this.props.loading;
  };

  reset() {
    this.setState(INITIAL_STATE);
  }

  componentWillUnmount() {
    this.reset();
  }

  formIsValid() {
    return true;
  }

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>
            {this.props.languageValues.cardAtividadesTitle}
            <HelpButton
              text={this.props.languageValues.atividadesTitleHint}
              className={rootClassName + '-title-hint'}
            />
          </CardTitle>
        ),
        actions: this.getActions(),
        bottomContent: (
          <Bullets
            total={this.props.totalBullets}
            selectedIndex={this.props.bulletsIndex}
          />
        ),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending: this.state.sending || this.props.loading,
      },
    };
  };

  submitCallbackStart = () => {
    this.setState({
      sending: true,
    });
  };

  submitCallbackSuccess = () => {
    this.setState({
      sending: false,
    });
    const idContrato =
      this.props.contratosEntePrivado.contratoEditing.idContrato;
    const idAditivo = this.props.contratosEntePrivado.contratoEditing.idAditivo;
    const idDistrato =
      this.props.contratosEntePrivado.contratoEditing.idDistrato;
    const etapa = CONTRATO_EDIT_ETAPA_VALIDACAO;
    switch (this.props.contratosEntePrivado.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        this.props.history.push(
          contratoAditivoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            idAditivo,
            etapa
          )
        );
        break;
      case CONTRATO_VERSAO_DISTRATO:
        this.props.history.push(
          contratoDistratoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            idDistrato,
            etapa
          )
        );
        break;
      default:
        this.props.history.push(
          contratoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            etapa
          )
        );
        break;
    }
  };

  submitCallbackError = () => {
    this.setState({
      sending: false,
    });
  };

  changeAtividades = (atividade, indexToRemove) => {
    let atividades = [
      ...(this.props.contratosEntePrivado.contratoEditing.atividades || []),
    ];
    if (atividade) {
      if (
        atividades.length > 0 &&
        atividade.index > -1 &&
        atividade.index < atividades.length
      ) {
        atividades[atividade.index] = atividade;
      } else {
        atividades.push(atividade);
      }
    }
    if (indexToRemove > -1) {
      atividades.splice(indexToRemove, 1);
    }
    atividades = fixAllAtividadesIndex(atividades);
    this.setValue({
      target: {
        name: 'atividades',
        value: atividades,
      },
    });
  };

  addAtividade = () => {
    this.props.openModal(CadastroAtividadesModal, {
      savedCallback: this.changeAtividades,
    });
  };

  escolaCompromissoCheckChanged = (check) => {
    this.setValue({
      target: {
        name: 'escolaCompromissoCheck',
        value: check,
      },
    });
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            if (this.formIsValid()) {
              this.toSubmit(
                2,
                this.props.contratosEntePrivado.contratoEditing,
                this.submitCallbackStart,
                this.submitCallbackSuccess,
                this.submitCallbackError
              );
            }
          }}
        >
          <button
            type='submit'
            className='hidden-button'
            disabled={this.submitButtonIsDisabled()}
          ></button>
          {
            <Col
              cols={[12, 12, 12, 12, 12]}
              className={rootClassName + `-atividades-table`}
            >
              <Atividades
                escolaCompromissoCheckChanged={
                  this.escolaCompromissoCheckChanged
                }
                addAtividade={this.addAtividade}
                editing={this.props.editing}
                changeAtividades={this.changeAtividades}
                fieldDisabled={this.fieldDisabled}
              />
            </Col>
          }
        </form>
      </GenericCardScreen>
    );
  }
}

DadosAtividades.propTypes = {
  editing: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePrivado: state.contratosEntePrivado,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      cadastroContratoEntePrivado,
      editarEntePrivado,
      editarAditivoEntePrivado,
      cadastroAditivoEntePrivado,
      cadastroDistratoEntePrivado,
      editarDistratoEntePrivado,
      changeContratoEntePrivadoEditingValue,
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DadosAtividades));
